import { SegmentEventData } from './types';

// NOTE: Kunal<kunal@styleseat.com> recommends moving this as an attribute. Which event TBD
const ClientPaymentModalSuccess: SegmentEventData = {
  eventName: 'client_paymentmodal_success',
  eventProperties: ['discount_code', 'discount_amount'],
};

export default ClientPaymentModalSuccess;
